import React, { useContext } from "react";
import './Mask.scss';
import { SettingsContext } from 'Providers/SettingsProvider';
function Mask() {
  const { tick } = useContext(SettingsContext);
  return tick>=2 ? '' : <div className="mask"></div>;
}
export default Mask;
